import React from 'react';
import { Gift, FileText, FileSpreadsheet } from 'lucide-react';
interface Bonus {
  title: string;
  image?: string;
}
interface BonusGridProps {
  bonuses: Bonus[];
}
function isExcel(title: string) {
  return /excel/i.test(title);
}
export function BonusGrid({
  bonuses
}: BonusGridProps) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-95">
      {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden border border-white/10 shadow-lg flex flex-col" data-id="element-96">
          {/* Preview image with gradient overlay */}
          <div className="relative h-40 bg-gradient-to-br from-blue-800 to-blue-950 flex items-center justify-center overflow-hidden" data-id="element-97">
            {bonus.image ? <>
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover object-top" data-id="element-98" />
                {/* Degrade / fade preview at the bottom of the image */}
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/20 to-transparent" data-id="element-99" />
                <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-transparent" data-id="element-100" />
              </> : <div className="flex flex-col items-center justify-center text-blue-200" data-id="element-101">
                <Gift className="w-12 h-12 mb-1" data-id="element-102" />
                <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-103">
                  Bonus Esclusivo
                </span>
              </div>}
            <span className="absolute top-3 left-3 bg-yellow-400 text-blue-950 text-xs font-black px-2.5 py-1 rounded-full shadow uppercase tracking-wide" data-id="element-104">
              Bonus {i + 1}
            </span>
          </div>

          {/* Title */}
          <div className="p-4 flex items-start gap-2 flex-1" data-id="element-105">
            {isExcel(bonus.title) ? <FileSpreadsheet className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-106" /> : <FileText className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-107" />}
            <span className="font-bold text-gray-900 text-sm leading-snug" data-id="element-108">
              {bonus.title}
            </span>
          </div>
        </div>)}
    </div>;
}